import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MapStyleHelper } from 'src/app/helpers/mapStyle.helper';
import { AuthService } from 'src/app/services/auth.service';
import { RosterService } from 'src/app/services/roster.service';
import { MirrorEvent, SignalRService } from 'src/app/services/signalR.service';
import { ToastService } from 'src/app/services/toast.service';
import { User1Service } from 'src/app/services/user1.service';
import { Role } from 'src/app/shared/role';

@Component({
  selector: 'app-emegency-dialog',
  templateUrl: './emegency-dialog.component.html',
  styleUrls: ['./emegency-dialog.component.scss'],
})
export class EmegencyDialogComponent  implements OnInit {
  map: google.maps.Map | undefined;
  @Input() data: any;
  staff: any;
  uniqueId = '';
  userLocationMarker: any;
  constructor(private modalCtrl: ModalController, 
    private rosterService: RosterService,  
    private toastService: ToastService,
    private userService: User1Service,
  private authService: AuthService,
  private signalRService: SignalRService) { }


  async ngOnInit() {
    this.uniqueId = 'map-emegency-' + Date.now().toString(36) + Math.random().toString(36).substring(2);
    console.log(this.uniqueId);
    
    this.doSubscribeMirrorEvent();
  }

  doSubscribeMirrorEvent() {
    if(!this.authService.hasRole(Role.ClientMirror))
      return;
    
    this.signalRService.mirrorMessages$.subscribe(async (messages: MirrorEvent[]) => {
        const event = messages[0];
        console.log(event.type, event.payload);
        if (event.type === "emergency-close") {
          this.modalCtrl.dismiss();
        }
    });
  }

  markAsDone() {
    const userId = this.data.userId;
    this.rosterService.updateEmergency(userId, true).subscribe(res => {
      this.toastService.presentToast('Emergency has been marked as resolved.');
      this.modalCtrl.dismiss({});
    });    
  }

  ngAfterViewInit() {
    this.initMap();
    this.getUserInfo();
  }

  getUserInfo() {
    this.userService.getUserInfo(this.data.userId).subscribe(res => {
      this.staff = res;
      console.log(this.staff);
    });
  }

  sourceLocation: any; 

  initMap() {
    const styledMapType = new google.maps.StyledMapType(MapStyleHelper.getCustomStyle(), {
            name: 'Luxury Dark',
        });
    
    const mapOptions: google.maps.MapOptions = {
        center: { lat: 3.1184561, lng: 101.6244935 },
        zoom: 15,
        mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
        },
        disableDefaultUI: true,
        zoomControl: true,
    };

    this.map = new google.maps.Map(document.getElementById(this.uniqueId) as HTMLElement, mapOptions);
    this.map.mapTypes.set('styled_map', styledMapType);
    this.map.setMapTypeId('styled_map');

    const userLocation = {
      lat: Number(this.data.latitude),
      lng:  Number(this.data.longitude),
    };    
    this.sourceLocation = userLocation;

    // Add a marker to indicate the user's location
    this.userLocationMarker = new google.maps.Marker({
      position: userLocation,
      map: this.map,
      title: 'Your Location',
    });

    // Center the map on the user's location
    this.map?.setCenter(userLocation);


    

   
    
    
  }

  drawRoute(origin: google.maps.LatLngLiteral, destination: google.maps.LatLngLiteral) {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: true, // Prevents default A/B markers
    });
    // Make sure your map is initialized before this
    directionsRenderer.setMap(this.map!);
  
    const request: google.maps.DirectionsRequest = {
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING, // or WALKING, BICYCLING, TRANSIT
    };
  
    directionsService.route(request, (result, status) => {
      // if (status === google.maps.DirectionsStatus.OK && result) {
      //   directionsRenderer.setDirections(result);
      // } else {
      //   console.error('Directions request failed due to ' + status);
      // }
      if (status === google.maps.DirectionsStatus.OK && result) {
        directionsRenderer.setDirections(result);
    
        const leg = result.routes[0].legs[0];
    
        // Custom marker for origin
        new google.maps.Marker({
          position: leg.start_location,
          map: this.map,
          // icon: 'assets/icons/destination-router-icon.png', // or use label/icon
          icon: {
            url: 'assets/icons/destination-router-icon.png', // or use label/icon
            scaledSize: new google.maps.Size(50, 50), // Adjust as needed
            anchor: new google.maps.Point(25, 50), // Center bottom anchor
          },
          title: 'End Point',
        });
    
        // Custom marker for destination
        new google.maps.Marker({
          position: leg.end_location,
          map: this.map,
          // icon: 'assets/icons/start-router-icon.png', // or use label/icon
          icon: {
            url: 'assets/icons/start-router-icon.png', // or use label/icon
            scaledSize: new google.maps.Size(50, 50),
            anchor: new google.maps.Point(25, 50),
          },
          title: 'Start Point',
        });

        // new google.maps.Marker({
        //   position: leg.end_location,
        //   map: this.map,
        //   label: {
        //     text: 'You are here', // or any text like 🚗 or 🏁
        //     fontWeight: 'bold',
        //     color: 'red',
        //     fontSize: '12px',
        //   },
        //   icon: {
        //     path: google.maps.SymbolPath.CIRCLE,
        //     scale: 10,
        //     fillColor: '#2e7d32',
        //     fillOpacity: 1,
        //     strokeColor: '#fff',
        //     strokeWeight: 1,
        //   },
        // });
      } else {
        console.error('Directions request failed due to ' + status);
      }
    });
  }

  cancel()  {
    this.modalCtrl.dismiss({senderId: this.data.userId});
  }

  showDirection() {
    // Remove userlocation marker
    this.userLocationMarker.setMap(null);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const origin = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const destination = this.sourceLocation; // your target location
        this.drawRoute(origin, destination);
        console.log(origin);
      },
      (error) => {
        console.error('Geolocation error', error);
      }
    );
  }
}
